// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 352 ? "commercial-vignette" : chunkId) + "." + {"37":"3ba8831a","239":"2f822dd7","283":"af3b9247","352":"93d4f5a2","451":"fc75f391","455":"eaad5ed6","667":"bd04abfc","899":"eb21f018","977":"4dc61a07","995":"8a7c0578"}[chunkId] + ".chunk.js";
};